import styled from 'styled-components';
import { palette } from 'styled-tools';

import {
	fontSize,
	FontSizes,
	fontWeight,
	FontWeights,
	lineHeight,
	minWidth,
	TextButton,
} from '@calm-web/design-system';

import lockIcon from 'icons/lock-outline.svg';

export const Wrapper = styled.li<{
	isAvailable: boolean;
}>`
	align-items: center;
	cursor: ${p => (p.isAvailable ? 'cursor' : 'pointer')};
	display: flex;
	opacity: ${p => (p.isAvailable ? '1' : '0.8')};
	margin: 0 auto;
	padding: 16px 0 24px;
	pointer-events: ${p => (p.isAvailable ? 'auto' : 'none')};
	max-width: 480px;
	z-index: 0;
`;

export const ClickableWrapper = styled(TextButton).attrs({
	textColor: 'white',
})`
	text-decoration: none;
	flex: 1;
`;

export const GuidePosition = styled.svg<{
	$isCompleted: boolean;
}>`
	flex: 0 0 16px;
	height: 16px;
	margin-right: 8px;
	position: relative;
	top: 2px;
	width: 16px;

	& path {
		fill: ${p => (p.$isCompleted ? palette('accessibleBrandGradient') : palette('white'))};
	}
`;

export const Title = styled.div<{
	isCourse: boolean;
}>`
	align-items: center;
	color: ${palette('white')};
	${fontSize(FontSizes.base)};
	${lineHeight(FontSizes.base)};
	${fontWeight(FontWeights.Medium)};
	display: flex;
	margin-bottom: 2px;
	text-align: left;
	width: 100%;
`;

// The second line both phone apps draw under a session's title. Scale, weight and the 2px
// gaps around it are PackRowList's row description rather than a fresh set of values: the two
// lists render the same sessions on the same page, one per programme, and mobile draws them
// with one type scale — so a programme without a packs feed shouldn't read a size apart from
// one with it.
export const Description = styled.div`
	color: ${palette('white')};
	font-size: 12px;
	font-weight: 500;
	margin: 0 0 2px;
	text-align: left;

	${minWidth('mobileLarge')} {
		font-size: 13px;
	}

	${minWidth('desktop')} {
		font-size: 14px;
	}
`;

// 12px/500 rather than the 13.5px/700 web drew before: both platforms render this line
// smaller and lighter than the title above it (Android 12sp/400, iOS 12pt medium), and web
// had it heavier than the title.
export const Duration = styled.div`
	font-size: 12px;
	font-weight: 500;
	text-align: left;
`;

export const LockIcon = styled(lockIcon)`
	flex: 0 0 24px;
	height: 24px;
	position: relative;
	width: 24px;
	z-index: 5;

	& path {
		fill: ${palette('white')};
	}
`;

// Sized to the button it holds and pulled 14px outward, matching how Android draws a row's
// fave (a 48dp box at the trailing edge with layout_marginEnd="-14dp") and keeping this list's
// hearts on the same centre line as the packs list's. At 24px the 48px button overflowed twice
// as far, putting part of the touch target off-screen at phone widths.
export const FaveHeartContainer = styled.div`
	flex-shrink: 0;
	margin-inline-end: -14px;
	width: 48px;
`;
